import React, { useEffect, useState, memo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { qrFrameText } from "../../../../../redux/slices/qrTextSettings";
import { qrFrameTextToggle } from "../../../../../redux/slices/qrFrames";
import { qrFrameTransform } from "../../../../../redux/slices/qrFrames";
import Form from "react-bootstrap/Form";
import FloatingLabel from "react-bootstrap/FloatingLabel";
import { useDebounce } from "use-debounce";

function FrameTextInput() {
  const lang = useSelector(
    (state) => state.changeLang.language.stepThree.frame
  );
  const frame = useSelector((state) => state.qrFrames.frame);
  const frameText = useSelector((state) => state.qrText.frameText);

  const dispatch = useDispatch();
  const [frameTextValue, setFrameText] = useState(frameText);
  const [debouncedframeTextValue] = useDebounce(frameTextValue, 500);

  useEffect(() => {
    dispatch(qrFrameText(debouncedframeTextValue));
    if (debouncedframeTextValue.length > 0) {
      dispatch(qrFrameTextToggle(true));
      frame === "noFrame" &&
        dispatch(qrFrameTransform("translate(30, 18)scale(0.8)"));
    } else {
      dispatch(qrFrameTextToggle(false));
      frame === "noFrame" &&
        dispatch(qrFrameTransform("translate(9, 9)scale(0.95)"));
    }
  }, [debouncedframeTextValue]);

  useEffect(() => {
    setFrameText(frameText);
  }, [frameText]);

  return (
    <>
      <FloatingLabel label={lang[2]}>
        <Form.Control
          type="text"
          value={frameTextValue}
          onChange={(e) => setFrameText(e.target.value)}
          placeholder={lang[2]}
          maxLength="20"
        />
      </FloatingLabel>
    </>
  );
}

export default memo(FrameTextInput);
